import React from 'react'
import { Link } from 'react-router-dom'

const LafId = ({ row, assignedLender }) => {
    return (
        <>
        { assignedLender == 16 ?
            <Link
                to={`/portfolio/collections/details/${row?.cl_lead_id}`}
            >
                {row?.laf_id}
            </Link>
            : row?.laf_id
        }
        </>
    )
}

export default LafId
